import { useTypingContext, useChatContext } from "stream-chat-react";
import { motion, AnimatePresence } from "framer-motion";

export const TypingIndicator = () => {
  const { typing } = useTypingContext();
  const { client } = useChatContext();

  const typingUsers = Object.values(typing || {}).filter(
    (evt) => evt.user?.id !== client.userID,
  );

  if (typingUsers.length === 0) return null;

  const names = typingUsers.map((e) => e.user?.name || "Someone");
  const text =
    names.length === 1
      ? `${names[0]} is typing`
      : names.length === 2
        ? `${names[0]} and ${names[1]} are typing`
        : `${names[0]} and ${names.length - 1} others are typing`;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: 4 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 4 }}
        className="px-4 py-1.5 text-xs text-slate-400 flex items-center gap-1.5"
      >
        <span className="flex gap-0.5">
          {[0, 1, 2].map((i) => (
            <motion.span
              key={i}
              className="w-1.5 h-1.5 rounded-full bg-indigo-400"
              animate={{ y: [0, -4, 0] }}
              transition={{
                repeat: Infinity,
                duration: 0.6,
                delay: i * 0.15,
              }}
            />
          ))}
        </span>
        <span>{text}</span>
      </motion.div>
    </AnimatePresence>
  );
};
